/**
 * The purpose of the message module is to store and manage data
 * for visualizing snackbar-messages.
 *
 * MESSAGE-BODY:
 *  title: '',
 *  message: '',
 *  state: MessageState.NOTIFICATION,
 *  duration: 3000, // Time in ms
 */

export const MessageState = {
    NOTIFICATION: 'NOTIFICATION',
    ERROR: 'ERROR',
};

export default {
    state: {
        messages: [],
    },
    getters: {
        getMessages: state => () => state.messages || [],
    },
    mutations: {
        addNewMessage(state, message) {
            message = {
                ...message,
                id: Date.now()
                    .toString()
                    .concat(Math.random() * 10),
            };
            state.messages.push(message);
        },
        deleteMessage(state, messageId) {
            const index = state.messages.findIndex(m => m.id === messageId);
            if (index !== -1) {
                state.messages.splice(index, 1);
            }
        },
    },
};
